(() => {
  const isTest = window.location.search.indexOf('ckcachecontrol') !== -1;
  const lang =  document.getElementsByTagName('html')[0].getAttribute('lang') === 'ja' ? 'ja' : 'en';
  const DATASET = document.getElementById('BRC-global-header').dataset;
  const HTML = `
  <header id="BRCGH">
    <div class="BRCGH-inner">
      <h1 class="BRCGH-logotype">
        <a href="${DATASET.origin}">${lang === 'ja' ? 'RIKEN BRC 理化学研究所バイオリソース研究センター' : 'RIKEN BRC RIKEN BioResource Resource Center'}</a>
      </h1>
      <div class="BRCGH-space"></div>
      <nav></nav>
      <div class="BRCGH-hamburger-menu"></div>
    </div>
  </header>`;
  const CSS = `#BRCGH {
    --color-key1: #111987;
    --color-key2: #078E53;
    --color-key1-softened: #212aaa;
    --color-key2-softened: #13b56e;
    --width-column: 240px;
    --gap-column: 20px;
    --padding-popup-side: 24px;
    --padding-sp-item: 10px 16px;
    --border-separator: solid 1px #999;
    min-width: 1024px;
    position: relative;
    width: 100%;
    background-color: white;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    z-index: 99998;
  }
  #BRCGH > .BRCGH-inner {
    margin: 0 auto;
    padding: 0 16px;
    position: relative;
    display: flex;
    align-items: center;
    height: 80px;
  }
  #BRCGH > .BRCGH-inner > .BRCGH-logotype > a {
    display: block;
    width: 186px;
    height: 53px;
    position: relative;
    top: 2px;
    text-indent: -9999px;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg%20id%3D%22logotype%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22209.495%22%20height%3D%2242.312%22%20viewBox%3D%220%200%20209.495%2042.312%22%3E%3Cdefs%3E%3Cstyle%3E.BRCGH-fillcolor1%7Bfill%3A%23111987%7D.BRCGH-fillcolor2%7Bfill%3A%23078e53%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath%20class%3D%22BRCGH-fillcolor1%22%20d%3D%22M1555.862%2C18.536h13.959a40.255%2C40.255%2C0%2C0%2C1%2C6.181.345%2C9.105%2C9.105%2C0%2C0%2C1%2C3.644%2C1.439%2C8.967%2C8.967%2C0%2C0%2C1%2C2.679%2C2.912%2C7.9%2C7.9%2C0%2C0%2C1%2C1.073%2C4.08%2C8.267%2C8.267%2C0%2C0%2C1-4.875%2C7.562%2C9.162%2C9.162%2C0%2C0%2C1%2C4.893%2C3.17%2C8.438%2C8.438%2C0%2C0%2C1%2C1.709%2C5.266%2C10.387%2C10.387%2C0%2C0%2C1-1.108%2C4.634%2C9.342%2C9.342%2C0%2C0%2C1-3.027%2C3.6%2C9.99%2C9.99%2C0%2C0%2C1-4.73%2C1.655q-1.764.192-8.506.238h-11.892Zm7.061%2C5.793V32.4h4.619q4.117%2C0%2C5.117-.118a4.659%2C4.659%2C0%2C0%2C0%2C2.845-1.251%2C3.7%2C3.7%2C0%2C0%2C0%2C1.036-2.729%2C3.844%2C3.844%2C0%2C0%2C0-.893-2.634%2C4.047%2C4.047%2C0%2C0%2C0-2.655-1.226q-1.047-.12-6.02-.118Zm0%2C13.869v9.346h6.539a32.21%2C32.21%2C0%2C0%2C0%2C4.843-.213%2C4.377%2C4.377%2C0%2C0%2C0%2C2.564-1.4%2C4.281%2C4.281%2C0%2C0%2C0%2C.992-2.968%2C4.551%2C4.551%2C0%2C0%2C0-.765-2.669%2C4.31%2C4.31%2C0%2C0%2C0-2.207-1.6%2C24.007%2C24.007%2C0%2C0%2C0-6.263-.5Z%22%20transform%3D%22translate(-1441.924%20-12.408)%22%20%2F%3E%3Cpath%20class%3D%22BRCGH-fillcolor2%22%20d%3D%22M1589.06%2C53.437v-34.9H1603.9a25.457%2C25.457%2C0%2C0%2C1%2C8.132.939%2C8.033%2C8.033%2C0%2C0%2C1%2C4.06%2C3.344%2C10.026%2C10.026%2C0%2C0%2C1%2C1.525%2C5.493%2C9.33%2C9.33%2C0%2C0%2C1-2.3%2C6.486%2C11.021%2C11.021%2C0%2C0%2C1-6.877%2C3.224%2C16.392%2C16.392%2C0%2C0%2C1%2C3.762%2C2.93%2C40.038%2C40.038%2C0%2C0%2C1%2C4%2C5.671l4.261%2C6.814h-8.429l-5.065-7.616a49.511%2C49.511%2C0%2C0%2C0-3.725-5.122%2C5.469%2C5.469%2C0%2C0%2C0-2.126-1.45%2C11.709%2C11.709%2C0%2C0%2C0-3.557-.392h-1.433v14.58Zm7.062-20.168h5.21a26.876%2C26.876%2C0%2C0%2C0%2C6.328-.428%2C3.8%2C3.8%2C0%2C0%2C0%2C1.975-1.473%2C4.548%2C4.548%2C0%2C0%2C0%2C.712-2.615%2C4.186%2C4.186%2C0%2C0%2C0-.939-2.84%2C4.317%2C4.317%2C0%2C0%2C0-2.653-1.364q-.857-.12-5.138-.12h-5.495Z%22%20transform%3D%22translate(-1441.924%20-12.408)%22%20%2F%3E%3Cpath%20class%3D%22BRCGH-fillcolor1%22%20d%3D%22M1644.561%2C39.973l6.858%2C2.134q-1.572%2C5.748-5.23%2C8.541a14.868%2C14.868%2C0%2C0%2C1-9.281%2C2.789%2C15.019%2C15.019%2C0%2C0%2C1-11.44-4.76q-4.481-4.761-4.48-13.017%2C0-8.731%2C4.5-13.563a15.429%2C15.429%2C0%2C0%2C1%2C11.842-4.832%2C14.539%2C14.539%2C0%2C0%2C1%2C10.411%2C3.784%2C13.755%2C13.755%2C0%2C0%2C1%2C3.573%2C6.427l-6.959%2C1.677a7.217%2C7.217%2C0%2C0%2C0-7.371-5.843%2C7.962%2C7.962%2C0%2C0%2C0-6.312%2C2.79q-2.422%2C2.79-2.422%2C9.037%2C0%2C6.627%2C2.381%2C9.441a7.724%2C7.724%2C0%2C0%2C0%2C6.19%2C2.812%2C7.048%2C7.048%2C0%2C0%2C0%2C4.833-1.789%2C10.39%2C10.39%2C0%2C0%2C0%2C2.9-5.628%22%20transform%3D%22translate(-1441.924%20-12.408)%22%20%2F%3E%3Cg%3E%3Cg%3E%3Cpath%20class%3D%22BRCGH-fillcolor1%22%20d%3D%22M1467.306%2C38.648a5.394%2C5.394%2C0%2C0%2C1-.4%2C1.6%2C18.125%2C18.125%2C0%2C0%2C0%2C2.8-2.833%2C15.758%2C15.758%2C0%2C0%2C0%2C3.247-9.525%2C15.475%2C15.475%2C0%2C0%2C0-30.941-.561c-.007.182-.078%2C1.519-.082%2C2.535V47.1s-.006.318%2C0%2C.849c0%2C.708.023%2C1.813.094%2C3a3.483%2C3.483%2C0%2C0%2C0%2C2.714%2C3.317%2C5.344%2C5.344%2C0%2C0%2C0%2C1.347.166c2.242%2C0%2C3.926-1.221%2C4.061-3.458.071-1.186.08-2.292.086-3%2C0-.514-.011-.874-.011-.874V28.67a8.511%2C8.511%2C0%2C0%2C1%2C1.032-4.7%2C7.4%2C7.4%2C0%2C0%2C1%2C6.238-3.434%2C7.277%2C7.277%2C0%2C0%2C1%2C7.278%2C7.277c0%2C.065%2C0%2C.564%2C0%2C.632a8.944%2C8.944%2C0%2C0%2C0-5.826-2.46%2C8.643%2C8.643%2C0%2C0%2C0-8.71%2C8.711%2C8.491%2C8.491%2C0%2C0%2C0%2C8.659%2C8.578c.26%2C0%2C.6-.011.99-.046a5.412%2C5.412%2C0%2C1%2C1%2C7.432-4.576Z%22%20transform%3D%22translate(-1441.924%20-12.408)%22%20%2F%3E%3Cpath%20class%3D%22BRCGH-fillcolor2%22%20d%3D%22M1467.814%2C43.278a5.721%2C5.721%2C0%2C1%2C0%2C5.72%2C5.721A5.722%2C5.722%2C0%2C0%2C0%2C1467.814%2C43.278Z%22%20transform%3D%22translate(-1441.924%20-12.408)%22%20%2F%3E%3C%2Fg%3E%3Cg%20transform%3D%22translate(36.342%2020.967)%22%3E%3Crect%20class%3D%22BRCGH-fillcolor1%22%20width%3D%223.759%22%20height%3D%2210.667%22%20transform%3D%22translate(33.479%209.396)%22%20%2F%3E%3Cpath%20class%3D%22BRCGH-fillcolor1%22%20d%3D%22M1499.094%2C34.682h-3.758V53.437h3.758V34.682%22%20transform%3D%22translate(-1478.266%20-33.375)%22%20%2F%3E%3Cpath%20class%3D%22BRCGH-fillcolor1%22%20d%3D%22M1506.639%2C45.517%22%20transform%3D%22translate(-1478.266%20-33.375)%22%20%2F%3E%3Crect%20class%3D%22BRCGH-fillcolor1%22%20width%3D%223.758%22%20height%3D%2218.756%22%20transform%3D%22translate(24.61%201.307)%22%20%2F%3E%3Cpath%20class%3D%22BRCGH-fillcolor1%22%20d%3D%22M1538.143%2C40.194V34.682h-3.757V53.437h3.757V40.194Z%22%20transform%3D%22translate(-1478.266%20-33.375)%22%20%2F%3E%3Cpath%20class%3D%22BRCGH-fillcolor1%22%20d%3D%22M1547.866%2C34.682h-3.76v10.8l-3.293-3.291-2.656%2C2.657%2C5.949%2C5.951v2.635h3.77Z%22%20transform%3D%22translate(-1478.266%20-33.375)%22%20%2F%3E%3Cpath%20class%3D%22BRCGH-fillcolor1%22%20d%3D%22M1509.323%2C44.489l8.42-8.438-2.678-2.675-8.418%2C8.422Z%22%20transform%3D%22translate(-1478.266%20-33.375)%22%20%2F%3E%3Cpath%20class%3D%22BRCGH-fillcolor1%22%20d%3D%22M1485.341%2C38.173a3.641%2C3.641%2C0%2C0%2C1%2C2.223%2C5.377%2C4.209%2C4.209%2C0%2C0%2C1-3.129%2C1.882h0l5.158%2C8.949%2C3.292-1.885-3.443-5.954s.005-.005%2C0%2C0a6.7%2C6.7%2C0%2C0%2C0%2C2.342-4.83%2C6.959%2C6.959%2C0%2C0%2C0-2.03-4.922%2C6.879%2C6.879%2C0%2C0%2C0-.937-.793%2C6.621%2C6.621%2C0%2C0%2C0-3.187-1.2%2C33.6%2C33.6%2C0%2C0%2C0-3.405-.108h-3.949v3.326h3.81a13.68%2C13.68%2C0%2C0%2C1%2C3.255.162%22%20transform%3D%22translate(-1478.266%20-33.375)%22%20%2F%3E%3Cpath%20class%3D%22BRCGH-fillcolor1%22%20d%3D%22M1478.266%2C47V40.964h3.758V53.437h-3.758V47%22%20transform%3D%22translate(-1478.266%20-33.375)%22%20%2F%3E%3Crect%20class%3D%22BRCGH-fillcolor1%22%20width%3D%2211.332%22%20height%3D%223.628%22%20transform%3D%22translate(41.011%201.307)%22%20%2F%3E%3Crect%20class%3D%22BRCGH-fillcolor1%22%20width%3D%2211.332%22%20height%3D%223.583%22%20transform%3D%22translate(41.011%2016.479)%22%20%2F%3E%3Crect%20class%3D%22BRCGH-fillcolor1%22%20width%3D%2211.332%22%20height%3D%223.624%22%20transform%3D%22translate(41.011%208.895)%22%20%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E");
  }
  #BRCGH > .BRCGH-inner > .BRCGH-logotype > a::before {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    width: 186px;
    height: 10px;
    background-repeat: no-repeat;
    background-position: 50% 100%;
    background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22208.44%22%20height%3D%229.756%22%20viewBox%3D%220%200%20208.44%209.756%22%3E%3Cpath%20d%3D%22M.882-9.141V0h1.09V-4.014h.754L5.719%2C0H7.053L3.932-4.025A2.553%2C2.553%2C0%2C0%2C0%2C6.426-6.6%2C2.4%2C2.4%2C0%2C0%2C0%2C5.174-8.839a3.713%2C3.713%2C0%2C0%2C0-1.786-.3Zm2.32%2C1c.789%2C0%2C2.146%2C0%2C2.146%2C1.543S3.758-4.988%2C3.19-4.988H1.972V-8.143Zm4.93-1V0H9.268V-9.141Zm4.153%2C0h-1.09V0h1.09V-4.814L16.46%2C0h1.415L13.41-5l4.106-4.141H16.147L12.284-5.174Zm7.621%2C3.909V-8.143h4.431v-1H18.815V0h5.7V-1H19.906V-4.234h4.048v-1Zm6-3.909V0h1.079V-8.027L32.213%2C0H33.8V-9.141H32.724v8.027L27.492-9.141Zm13.526%2C0V0h3.051c.847%2C0%2C3.178%2C0%2C3.178-2.575a2.319%2C2.319%2C0%2C0%2C0-1.473-2.239A2.063%2C2.063%2C0%2C0%2C0%2C45.344-6.8%2C2.137%2C2.137%2C0%2C0%2C0%2C44.1-8.886a4.133%2C4.133%2C0%2C0%2C0-1.775-.255Zm2.877%2C1c.754%2C0%2C1.972%2C0%2C1.972%2C1.462%2C0%2C1.438-1.38%2C1.438-1.694%2C1.438H40.519v-2.9Zm.418%2C3.874a1.619%2C1.619%2C0%2C0%2C1%2C1.833%2C1.612C44.556-1.125%2C43.477-1%2C42.386-1H40.519V-4.269Zm5.556-4.872H47.061v1.276h1.218ZM48.2-6.832H47.142V0H48.2ZM49.671-3.41a3.371%2C3.371%2C0%2C0%2C0%2C3.376%2C3.6%2C3.375%2C3.375%2C0%2C0%2C0%2C3.364-3.6%2C3.374%2C3.374%2C0%2C0%2C0-3.376-3.608A3.372%2C3.372%2C0%2C0%2C0%2C49.671-3.41Zm1.044%2C0a2.348%2C2.348%2C0%2C0%2C1%2C2.332-2.645%2C2.347%2C2.347%2C0%2C0%2C1%2C2.32%2C2.645A2.349%2C2.349%2C0%2C0%2C1%2C53.035-.766%2C2.353%2C2.353%2C0%2C0%2C1%2C50.715-3.41Zm7.076-5.73V0h1.09V-4.014h.754L62.628%2C0h1.334l-3.12-4.025A2.553%2C2.553%2C0%2C0%2C0%2C63.336-6.6a2.4%2C2.4%2C0%2C0%2C0-1.253-2.239%2C3.713%2C3.713%2C0%2C0%2C0-1.786-.3Zm2.32%2C1c.789%2C0%2C2.146%2C0%2C2.146%2C1.543S60.668-4.988%2C60.1-4.988H58.882V-8.143Zm10.568%2C5.1a5.846%2C5.846%2C0%2C0%2C0-.325-2.134%2C2.82%2C2.82%2C0%2C0%2C0-2.7-1.844c-1.763%2C0-3.132%2C1.427-3.132%2C3.642A3.263%2C3.263%2C0%2C0%2C0%2C67.988.186a5.133%2C5.133%2C0%2C0%2C0%2C2.146-.441V-1.369a3.837%2C3.837%2C0%2C0%2C1-2.146.6A2.211%2C2.211%2C0%2C0%2C1%2C65.54-3.039Zm-5.127-.928A2.071%2C2.071%2C0%2C0%2C1%2C67.6-6.055a2.007%2C2.007%2C0%2C0%2C1%2C2.018%2C2.088ZM76.073-6.589a4.048%2C4.048%2C0%2C0%2C0-1.8-.429c-1.3%2C0-2.413.708-2.413%2C1.972%2C0%2C1.346%2C1.079%2C1.694%2C2.146%2C2%2C.673.2%2C1.45.418%2C1.45%2C1.183%2C0%2C1.1-1.45%2C1.1-1.694%2C1.1a3.82%2C3.82%2C0%2C0%2C1-1.891-.487l-.348.893a4.724%2C4.724%2C0%2C0%2C0%2C2.216.545c1.218%2C0%2C2.761-.5%2C2.761-2.065%2C0-1.369-1.183-1.74-1.949-1.984-1.276-.394-1.659-.522-1.659-1.218%2C0-.742.742-.974%2C1.392-.974a2.8%2C2.8%2C0%2C0%2C1%2C1.52.418ZM77.488-3.41a3.371%2C3.371%2C0%2C0%2C0%2C3.376%2C3.6%2C3.375%2C3.375%2C0%2C0%2C0%2C3.364-3.6%2C3.374%2C3.374%2C0%2C0%2C0-3.376-3.608A3.372%2C3.372%2C0%2C0%2C0%2C77.488-3.41Zm1.044%2C0a2.348%2C2.348%2C0%2C0%2C1%2C2.332-2.645%2C2.347%2C2.347%2C0%2C0%2C1%2C2.32%2C2.645A2.349%2C2.349%2C0%2C0%2C1%2C80.852-.766%2C2.353%2C2.353%2C0%2C0%2C1%2C78.532-3.41ZM90-6.832v3.851C90-.847%2C88.438-.766%2C88.114-.766%2C86.64-.766%2C86.64-1.9%2C86.64-2.981V-6.832H85.608v3.851A4.358%2C4.358%2C0%2C0%2C0%2C85.9-.9a2.106%2C2.106%2C0%2C0%2C0%2C1.96%2C1.09A2.565%2C2.565%2C0%2C0%2C0%2C90-.9V0h1.044V-6.832ZM93.832%2C0V-3.851c0-1.508.719-2.227%2C2.2-2.2v-.963a2.375%2C2.375%2C0%2C0%2C0-2.2%2C1.09v-.9H92.8V0Zm8.654-1.369a3.524%2C3.524%2C0%2C0%2C1-1.984.6%2C2.4%2C2.4%2C0%2C0%2C1-2.54-2.645%2C2.424%2C2.424%2C0%2C0%2C1%2C2.517-2.656%2C2.537%2C2.537%2C0%2C0%2C1%2C1.717.6l.29-.951a3.578%2C3.578%2C0%2C0%2C0-2.053-.6%2C3.443%2C3.443%2C0%2C0%2C0-3.515%2C3.654%2C3.325%2C3.325%2C0%2C0%2C0%2C3.561%2C3.55%2C3.922%2C3.922%2C0%2C0%2C0%2C2.007-.464Zm7.18-1.67a5.846%2C5.846%2C0%2C0%2C0-.325-2.134%2C2.82%2C2.82%2C0%2C0%2C0-2.7-1.844c-1.763%2C0-3.132%2C1.427-3.132%2C3.642A3.263%2C3.263%2C0%2C0%2C0%2C106.975.186a5.133%2C5.133%2C0%2C0%2C0%2C2.146-.441V-1.369a3.837%2C3.837%2C0%2C0%2C1-2.146.6%2C2.211%2C2.211%2C0%2C0%2C1-2.448-2.274Zm-5.127-.928a2.071%2C2.071%2C0%2C0%2C1%2C2.053-2.088%2C2.007%2C2.007%2C0%2C0%2C1%2C2.018%2C2.088Zm10.382-5.174V0h1.09V-4.014h.754L119.758%2C0h1.334l-3.12-4.025A2.553%2C2.553%2C0%2C0%2C0%2C120.466-6.6a2.4%2C2.4%2C0%2C0%2C0-1.253-2.239%2C3.713%2C3.713%2C0%2C0%2C0-1.786-.3Zm2.32%2C1c.789%2C0%2C2.146%2C0%2C2.146%2C1.543S117.8-4.988%2C117.23-4.988h-1.218V-8.143Zm10.568%2C5.1a5.846%2C5.846%2C0%2C0%2C0-.325-2.134%2C2.82%2C2.82%2C0%2C0%2C0-2.7-1.844c-1.763%2C0-3.132%2C1.427-3.132%2C3.642A3.263%2C3.263%2C0%2C0%2C0%2C125.118.186a5.133%2C5.133%2C0%2C0%2C0%2C2.146-.441V-1.369a3.837%2C3.837%2C0%2C0%2C1-2.146.6%2C2.211%2C2.211%2C0%2C0%2C1-2.448-2.274Zm-5.127-.928a2.071%2C2.071%2C0%2C0%2C1%2C2.053-2.088%2C2.007%2C2.007%2C0%2C0%2C1%2C2.018%2C2.088ZM133.2-6.589a4.048%2C4.048%2C0%2C0%2C0-1.8-.429c-1.3%2C0-2.413.708-2.413%2C1.972%2C0%2C1.346%2C1.079%2C1.694%2C2.146%2C2%2C.673.2%2C1.45.418%2C1.45%2C1.183%2C0%2C1.1-1.45%2C1.1-1.694%2C1.1A3.82%2C3.82%2C0%2C0%2C1%2C129-1.253l-.348.893a4.724%2C4.724%2C0%2C0%2C0%2C2.216.545c1.218%2C0%2C2.761-.5%2C2.761-2.065%2C0-1.369-1.183-1.74-1.949-1.984-1.276-.394-1.659-.522-1.659-1.218%2C0-.742.742-.974%2C1.392-.974a2.8%2C2.8%2C0%2C0%2C1%2C1.52.418Zm7.6%2C3.55a5.846%2C5.846%2C0%2C0%2C0-.325-2.134%2C2.82%2C2.82%2C0%2C0%2C0-2.7-1.844c-1.763%2C0-3.132%2C1.427-3.132%2C3.642A3.263%2C3.263%2C0%2C0%2C0%2C138.11.186a5.133%2C5.133%2C0%2C0%2C0%2C2.146-.441V-1.369a3.837%2C3.837%2C0%2C0%2C1-2.146.6%2C2.211%2C2.211%2C0%2C0%2C1-2.448-2.274Zm-5.127-.928a2.071%2C2.071%2C0%2C0%2C1%2C2.053-2.088%2C2.007%2C2.007%2C0%2C0%2C1%2C2.018%2C2.088Zm6.925-1.45a3.941%2C3.941%2C0%2C0%2C1%2C2.111-.638c.87%2C0%2C1.717.325%2C1.717%2C1.114%2C0%2C.557-.336.592-1.311.708-1.183.139-3.26.383-3.26%2C2.424a1.939%2C1.939%2C0%2C0%2C0%2C2.158%2C2%2C3.243%2C3.243%2C0%2C0%2C0%2C2.448-1.032%2C1.688%2C1.688%2C0%2C0%2C0%2C.186.847h1.09a2.649%2C2.649%2C0%2C0%2C1-.255-1.288V-4.42a2.407%2C2.407%2C0%2C0%2C0-.464-1.74%2C3.071%2C3.071%2C0%2C0%2C0-2.3-.858%2C4.385%2C4.385%2C0%2C0%2C0-2.216.568Zm3.851%2C3.26a2.8%2C2.8%2C0%2C0%2C1-2.366%2C1.415%2C1.073%2C1.073%2C0%2C0%2C1-1.206-1.1c0-1.137%2C1.114-1.334%2C2.123-1.462a4.517%2C4.517%2C0%2C0%2C0%2C1.45-.278ZM150.313%2C0V-3.851c0-1.508.719-2.227%2C2.2-2.2v-.963a2.375%2C2.375%2C0%2C0%2C0-2.2%2C1.09v-.9H149.28V0Zm8.654-1.369a3.524%2C3.524%2C0%2C0%2C1-1.984.6%2C2.4%2C2.4%2C0%2C0%2C1-2.54-2.645%2C2.424%2C2.424%2C0%2C0%2C1%2C2.517-2.656%2C2.537%2C2.537%2C0%2C0%2C1%2C1.717.6l.29-.951a3.578%2C3.578%2C0%2C0%2C0-2.053-.6A3.443%2C3.443%2C0%2C0%2C0%2C153.4-3.364%2C3.325%2C3.325%2C0%2C0%2C0%2C156.96.186a3.922%2C3.922%2C0%2C0%2C0%2C2.007-.464ZM161.379%2C0V-3.851c0-2.123%2C1.566-2.216%2C1.891-2.216%2C1.473%2C0%2C1.473%2C1.148%2C1.473%2C2.216V0h1.044V-3.851a4.247%2C4.247%2C0%2C0%2C0-.3-2.076%2C2.092%2C2.092%2C0%2C0%2C0-1.96-1.09%2C2.565%2C2.565%2C0%2C0%2C0-2.146%2C1.09V-9.57h-1.032V0Zm17.33-1.694A4.217%2C4.217%2C0%2C0%2C1%2C176-.812a3.591%2C3.591%2C0%2C0%2C1-3.851-3.758%2C3.6%2C3.6%2C0%2C0%2C1%2C3.735-3.758%2C3.765%2C3.765%2C0%2C0%2C1%2C2.459.835l.371-1a4.922%2C4.922%2C0%2C0%2C0-2.807-.835%2C4.633%2C4.633%2C0%2C0%2C0-4.849%2C4.779%2C4.551%2C4.551%2C0%2C0%2C0%2C4.86%2C4.733%2C5.661%2C5.661%2C0%2C0%2C0%2C2.8-.673ZM185.9-3.039a5.846%2C5.846%2C0%2C0%2C0-.325-2.134%2C2.82%2C2.82%2C0%2C0%2C0-2.7-1.844c-1.763%2C0-3.132%2C1.427-3.132%2C3.642A3.263%2C3.263%2C0%2C0%2C0%2C183.21.186a5.133%2C5.133%2C0%2C0%2C0%2C2.146-.441V-1.369a3.837%2C3.837%2C0%2C0%2C1-2.146.6%2C2.211%2C2.211%2C0%2C0%2C1-2.448-2.274Zm-5.127-.928a2.071%2C2.071%2C0%2C0%2C1%2C2.053-2.088%2C2.007%2C2.007%2C0%2C0%2C1%2C2.018%2C2.088ZM188.326%2C0V-3.851c0-2.123%2C1.566-2.216%2C1.891-2.216%2C1.473%2C0%2C1.473%2C1.148%2C1.473%2C2.216V0h1.044V-3.851a4.413%2C4.413%2C0%2C0%2C0-.3-2.076%2C2.092%2C2.092%2C0%2C0%2C0-1.96-1.09%2C2.536%2C2.536%2C0%2C0%2C0-2.146%2C1.09v-.9h-1.032V0Zm6.368-6.832h-.882v.963h.882v3.9c0%2C1.021.046%2C2.158%2C1.937%2C2.158A7.308%2C7.308%2C0%2C0%2C0%2C197.71.1V-.847a6.968%2C6.968%2C0%2C0%2C1-.928.081c-1.056%2C0-1.056-.568-1.056-1.206v-3.9H197.8v-.963h-2.076v-1.96h-1.032Zm10%2C3.793a5.846%2C5.846%2C0%2C0%2C0-.325-2.134%2C2.82%2C2.82%2C0%2C0%2C0-2.7-1.844c-1.763%2C0-3.132%2C1.427-3.132%2C3.642A3.263%2C3.263%2C0%2C0%2C0%2C202%2C.186a5.133%2C5.133%2C0%2C0%2C0%2C2.146-.441V-1.369a3.837%2C3.837%2C0%2C0%2C1-2.146.6%2C2.211%2C2.211%2C0%2C0%2C1-2.448-2.274Zm-5.127-.928a2.071%2C2.071%2C0%2C0%2C1%2C2.053-2.088%2C2.007%2C2.007%2C0%2C0%2C1%2C2.018%2C2.088ZM207.118%2C0V-3.851c0-1.508.719-2.227%2C2.2-2.2v-.963a2.375%2C2.375%2C0%2C0%2C0-2.2%2C1.09v-.9h-1.032V0Z%22%20transform%3D%22translate(-0.882%209.57)%22%2F%3E%3C%2Fsvg%3E");
  }
  [lang=ja] #BRCGH > .BRCGH-inner > .BRCGH-logotype > a::before {
    background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22209.857%22%20height%3D%2210.845%22%20viewBox%3D%220%200%20209.857%2010.845%22%3E%3Cpath%20d%3D%22M4.34-9.069v5.217H6.926v1.265H4.262v.821H6.926V-.2H3.63V.633h7.049V-.2H7.792V-1.765h2.686v-.821H7.792V-3.852h2.575V-9.069ZM6.926-6.838H5.195V-8.27H6.926Zm0%2C2.2H5.195V-6.094H6.926Zm2.586-2.2H7.792V-8.27h1.72Zm0%2C2.2H7.792V-6.094h1.72ZM3.963-2.065c-.411.155-.755.289-1.3.477V-4.551h1.1v-.866h-1.1V-7.959h1.3v-.855H.411v.855H1.776v2.542H.522v.866H1.776V-1.31C1.265-1.177.655-1%2C.266-.91L.411%2C0A29.772%2C29.772%2C0%2C0%2C0%2C3.974-1.154ZM13.908-6.6a12.56%2C12.56%2C0%2C0%2C0%2C1.055-2.6l-.91-.155a10.017%2C10.017%2C0%2C0%2C1-2.72%2C4.606l.511.977a7.079%2C7.079%2C0%2C0%2C0%2C1.121-1.288V.944h.943Zm7.071-.721A12.407%2C12.407%2C0%2C0%2C1%2C17.338-5.35V-9.368h-.932v9.18c0%2C.866.633.921%2C1.066.921h3.064c.588%2C0%2C1.277%2C0%2C1.288-2.7L20.868-2.2c-.011%2C2.02-.189%2C2.02-.6%2C2.02H17.827c-.433%2C0-.488-.089-.488-.488V-4.418A14.6%2C14.6%2C0%2C0%2C0%2C21.6-6.571Zm3.852-.255.555-.211a6.094%2C6.094%2C0%2C0%2C0-.855-1.576l-.821.322a6.577%2C6.577%2C0%2C0%2C1%2C.766%2C1.465H22.866v2.453h.91V-6.76h7.936v1.632h.91V-7.581h-1.61a11.425%2C11.425%2C0%2C0%2C0%2C.788-1.51l-.966-.322A16.258%2C16.258%2C0%2C0%2C1%2C30-7.581Zm3.6-.311a8.794%2C8.794%2C0%2C0%2C0-.844-1.621l-.855.344a9.507%2C9.507%2C0%2C0%2C1%2C.844%2C1.576ZM31.08-5.761H24.387v.821H29.6a6.355%2C6.355%2C0%2C0%2C1-1.8%2C1.054h-.477v.921H22.6v.855h4.729V-.355c0%2C.255-.022.344-.366.344L25.153-.022l.178.955h2.02a.814.814%2C0%2C0%2C0%2C.91-.855V-2.109h4.618v-.855H28.261V-3.2A12.585%2C12.585%2C0%2C0%2C0%2C31.08-5.006Zm4.351.022a10.14%2C10.14%2C0%2C0%2C0%2C.433-2.342h1.72v-.866h-3.9v.866h1.3a6%2C6%2C0%2C0%2C1-1.465%2C4.118l.4%2C1a3.722%2C3.722%2C0%2C0%2C0%2C.611-.744V.411H37.4V-5.739ZM36.6-.422H35.354V-4.939H36.6Zm6.094-7.659h1.154v-.866H38.051v.866h1.01v2.808H37.873v.866h1.188v.677a5.547%2C5.547%2C0%2C0%2C1-1.41%2C4l.8.655c1.443-1.432%2C1.521-3.807%2C1.521-4.584v-.744H41.78V.932h.91V-4.407h1.321v-.866H42.691Zm-.91%2C2.808H39.971V-8.081H41.78Zm11.7.244c.644%2C0%2C.821-.4.9-1.387h.411v-2h-4.4v-.955h-.91v.955H45.11v2.2h.91V-7.581h2.1c-.211.666-.7%2C1.732-2.864%2C2.153l.322.855c2.7-.766%2C3.208-2.087%2C3.408-3.008h1.576v1.8c0%2C.611.3.755.866.755Zm.089-1.609c-.044.566-.056.81-.422.81H51.671c-.3%2C0-.3-.122-.3-.278V-7.581h2.542v1.032ZM45.221.988c3.608-1.121%2C4.107-3.241%2C4.3-4.074H51.9V-.133c0%2C.322%2C0%2C.921.81.921h1.454c.788%2C0%2C.888-.522.921-2.253l-.855-.2c-.022%2C1.277-.056%2C1.587-.422%2C1.587h-.744c-.255%2C0-.278-.078-.278-.3V-3.952H49.673a11.7%2C11.7%2C0%2C0%2C0%2C.111-1.232h-.91a9.68%2C9.68%2C0%2C0%2C1-.1%2C1.232h-3.4v.866h3.23c-.189.766-.644%2C2.364-3.83%2C3.175ZM60.906-9H55.944v.855h4.962Zm1.388%2C1.177a12.888%2C12.888%2C0%2C0%2C0%2C3.685-.766l-.533-.821a12.372%2C12.372%2C0%2C0%2C1-4.063.8V-4.54a9.835%2C9.835%2C0%2C0%2C1-.4%2C2.819%2C4.472%2C4.472%2C0%2C0%2C1-1.188%2C2L60.628.9c.411-.511%2C1.665-2.02%2C1.665-5.716v-.255h1.632V.944h.921V-5.073h1.332v-.866H62.293Zm-5.717.844v3.719a12.321%2C12.321%2C0%2C0%2C1-.189%2C1.92%2C4.241%2C4.241%2C0%2C0%2C1-.6%2C1.587l.766.666a8.521%2C8.521%2C0%2C0%2C0%2C.91-3.83h3.053V-6.982ZM59.64-3.763H57.465V-6.149H59.64Zm10.212-4.7A17.206%2C17.206%2C0%2C0%2C1%2C67.111-.4l.977.522A18.45%2C18.45%2C0%2C0%2C0%2C70.907-8.3ZM76.535-.344a26.1%2C26.1%2C0%2C0%2C0-2.83-8.17l-.932.444A25.462%2C25.462%2C0%2C0%2C1%2C75.436-.078ZM74.426-8.78a9.575%2C9.575%2C0%2C0%2C1%2C1.1%2C2.12l.755-.444A9.439%2C9.439%2C0%2C0%2C0%2C75.125-9.18Zm1.51-.677a9.144%2C9.144%2C0%2C0%2C1%2C1.1%2C2.12l.755-.444a9.671%2C9.671%2C0%2C0%2C0-1.143-2.076Zm8.5%2C3.974A20.318%2C20.318%2C0%2C0%2C0%2C87.4-8.38l-.932-.611A16.554%2C16.554%2C0%2C0%2C1%2C78.51-3.4L79-2.475A17.675%2C17.675%2C0%2C0%2C0%2C83.372-4.7V.477h1.066Zm10.512-.611A15.962%2C15.962%2C0%2C0%2C1%2C89.51-1.288l.633.8a14.672%2C14.672%2C0%2C0%2C0%2C5.006-4.44v3.907c0%2C.344-.111.488-.61.488a13.729%2C13.729%2C0%2C0%2C1-1.554-.133l.1%2C1.01c.9.078%2C1.177.1%2C1.576.1.932%2C0%2C1.5-.3%2C1.5-1.321V-6.094h2.7v-.943h-2.7v-1.9H95.138v1.9H89.843v.943Zm8.125-2.531h-1.021v5.961h1.021Zm5.661-.178h-1.043v4.784c0%2C2.83-2.131%2C3.319-5.128%2C3.463l.3.966c2.83-.178%2C5.872-.788%2C5.872-4.5Zm6.394%2C3.674a12.691%2C12.691%2C0%2C0%2C0-2.065-2.986l-.866.488a13.474%2C13.474%2C0%2C0%2C1%2C1.965%2C3.052ZM113.719.344c5.239-1.321%2C6.493-5.173%2C7.193-8.547l-1.11-.2c-.733%2C4.107-2.331%2C6.893-6.727%2C7.859Zm9.158-5.095V-3.7h9.546V-4.751Zm11.666-3.608v.944H140.5a11.421%2C11.421%2C0%2C0%2C1-2.364%2C3.974%2C11.66%2C11.66%2C0%2C0%2C1-4.151%2C3l.6.821a13.744%2C13.744%2C0%2C0%2C0%2C4.5-3.419A39.509%2C39.509%2C0%2C0%2C1%2C142.624.333l.844-.8a43.529%2C43.529%2C0%2C0%2C0-3.774-3.33%2C11.977%2C11.977%2C0%2C0%2C0%2C2.12-4.562Zm11.888%2C2.62a10.14%2C10.14%2C0%2C0%2C0%2C.433-2.342h1.721v-.866h-3.9v.866h1.3a6%2C6%2C0%2C0%2C1-1.465%2C4.118l.4%2C1a3.722%2C3.722%2C0%2C0%2C0%2C.611-.744V.411H148.4V-5.739ZM147.6-.422h-1.243V-4.939H147.6Zm6.094-7.659h1.154v-.866h-5.794v.866h1.01v2.808h-1.188v.866h1.188v.677a5.547%2C5.547%2C0%2C0%2C1-1.41%2C4l.8.655c1.443-1.432%2C1.521-3.807%2C1.521-4.584v-.744h1.809V.932h.91V-4.407h1.321v-.866h-1.321Zm-.91%2C2.808h-1.809V-8.081h1.809Zm11.7.244c.644%2C0%2C.821-.4.9-1.387h.411v-2h-4.4v-.955h-.91v.955H156.11v2.2h.91V-7.581h2.1c-.211.666-.7%2C1.732-2.864%2C2.153l.322.855c2.7-.766%2C3.208-2.087%2C3.408-3.008h1.576v1.8c0%2C.611.3.755.866.755Zm.089-1.609c-.044.566-.055.81-.422.81h-1.476c-.3%2C0-.3-.122-.3-.278V-7.581h2.542v1.032ZM156.221.988c3.607-1.121%2C4.107-3.241%2C4.3-4.074H162.9V-.133c0%2C.322%2C0%2C.921.81.921h1.454c.788%2C0%2C.888-.522.921-2.253l-.855-.2c-.022%2C1.277-.055%2C1.587-.422%2C1.587h-.744c-.255%2C0-.277-.078-.277-.3V-3.952h-3.119a11.7%2C11.7%2C0%2C0%2C0%2C.111-1.232h-.91a9.679%2C9.679%2C0%2C0%2C1-.1%2C1.232h-3.4v.866h3.23c-.189.766-.644%2C2.364-3.829%2C3.175ZM169.8-5.506v3.63c0%2C1.288.422%2C2.076%2C2.331%2C2.076H174.5a12.763%2C12.763%2C0%2C0%2C0%2C1.943-.122l-.022-1a11.272%2C11.272%2C0%2C0%2C1-1.987.155h-2.242c-.977%2C0-1.388-.133-1.388-1.166V-5.594l4.584-.4a3.873%2C3.873%2C0%2C0%2C1-2.7%2C2.786l.588.788a5.147%2C5.147%2C0%2C0%2C0%2C3.341-4.6l-5.816.455V-8.947H169.8v2.464l-2.409.189.055.988Zm13-1.177a13.93%2C13.93%2C0%2C0%2C0-3.474-1.554l-.5.888a13.247%2C13.247%2C0%2C0%2C1%2C3.419%2C1.6ZM179.254.178c6.394-.422%2C8.17-5.606%2C8.7-7.182l-.866-.644c-.766%2C2.486-2.42%2C6.416-8.036%2C6.716Zm11.1-4.429a6.842%2C6.842%2C0%2C0%2C0%2C1.41-1.121%2C16.314%2C16.314%2C0%2C0%2C1%2C3.53%2C2.3%2C9.29%2C9.29%2C0%2C0%2C1-4.806%2C2.642l.477.921A9.347%2C9.347%2C0%2C0%2C0%2C198.4-8.358h-5.739a7.337%2C7.337%2C0%2C0%2C1-2.964%2C3.33Zm6.9-3.186A8.061%2C8.061%2C0%2C0%2C1%2C195.9-3.83a17.053%2C17.053%2C0%2C0%2C0-3.53-2.209%2C8.953%2C8.953%2C0%2C0%2C0%2C.955-1.4Zm3.319%2C2.686V-3.7h9.546V-4.751Z%22%20transform%3D%22translate(-0.266%209.857)%22%2F%3E%3C%2Fsvg%3E");
  }
  #BRCGH > .BRCGH-inner > .BRCGH-space {
    flex-grow: 1;
  }
  #BRCGH > .BRCGH-inner > nav {
    display: flex;
    padding: 0 20px;
    flex-direction: column;
  }
  #BRCGH > .BRCGH-inner > nav ul {
    list-style: none;
  }
  #BRCGH > .BRCGH-inner > nav a {
    color: black;
    font-weight: bold;
    text-decoration: none;
  }
  #BRCGH > .BRCGH-inner > nav a:hover {
    color: var(--color-key1);
    text-decoration: underline;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary, #BRCGH > .BRCGH-inner > nav > .BRCGH-secondary {
    text-align: right;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li, #BRCGH > .BRCGH-inner > nav > .BRCGH-secondary > li {
    display: inline-block;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li + li, #BRCGH > .BRCGH-inner > nav > .BRCGH-secondary > li + li {
    margin-left: 1.5em;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li br, #BRCGH > .BRCGH-inner > nav > .BRCGH-secondary > li br {
    display: none;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary {
    font-size: 1.8rem;
    line-height: 1;
    order: 1;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li {
    position: relative;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > a::before, #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view {
    pointer-events: none;
    opacity: 0;
    transform: translateY(-8px);
    transition: opacity 0.2s, transform 0.2s;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > a {
    position: relative;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > a::before {
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 6px 7px 6px;
    border-color: transparent transparent var(--color-key1) transparent;
    position: absolute;
    left: calc(50% - 6px);
    top: 22px;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view {
    position: absolute;
    top: 28px;
    text-align: left;
    background-color: white;
    box-shadow: 0 18px 24px rgba(0, 0, 0, 0.4);
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view::before {
    content: "";
    width: 100%;
    height: 10px;
    position: absolute;
    top: -10px;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-popupmenu-title {
    padding: 18px var(--padding-popup-side) 12px;
    color: white;
    background: linear-gradient(124deg, #212aaa -100%, #13b56e 200%);
    font-size: 2.1rem;
    line-height: 1;
    font-weight: bold;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns {
    padding: 18px var(--padding-popup-side) 24px;
    display: flex;
    gap: var(--gap-column);
    flex-wrap: wrap;
    min-width: calc(var(--width-column) * 4 + var(--gap-column) * 3 + var(--padding-popup-side) * 2);
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column {
    width: var(--width-column);
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column > .BRCGH-column-title {
    color: var(--color-key1);
    border-bottom: solid 1px #0006;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column > .BRCGH-column-title > .BRCGH-collapsebutton {
    border: none;
    background-color: transparent;
    padding: 0;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column > ul > li {
    font-size: 1.4rem;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column > ul > li > a {
    padding: 4px 0;
    display: block;
    position: relative;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column > ul > li > a::after {
    content: "";
    display: inline-block;
    width: 0.3rem;
    height: 0.3rem;
    border-top: solid 0.2rem var(--color-key1);
    border-right: solid 0.2rem var(--color-key1);
    transform: rotate(45deg);
    position: relative;
    top: -2px;
    left: 4px;
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view[data-column-count="1"] > .BRCGH-columns {
    min-width: calc(var(--width-column) * 1 + var(--gap-column) * 0 + var(--padding-popup-side) * 2);
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view[data-column-count="2"] > .BRCGH-columns {
    min-width: calc(var(--width-column) * 2 + var(--gap-column) * 1 + var(--padding-popup-side) * 2);
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view[data-column-count="3"] > .BRCGH-columns {
    min-width: calc(var(--width-column) * 3 + var(--gap-column) * 2 + var(--padding-popup-side) * 2);
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li:hover > a::before, #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li:hover > .BRCGH-popupmenu-view, #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li:focus-within > a::before, #BRCGH > .BRCGH-inner > nav > .BRCGH-primary > li:focus-within > .BRCGH-popupmenu-view {
    pointer-events: auto;
    opacity: 1;
    transform: translateY(0px);
  }
  #BRCGH > .BRCGH-inner > nav > .BRCGH-secondary {
    padding-bottom: 8px;
    font-size: 1.4rem;
    line-height: 1;
    order: 0;
  }
  #BRCGH > .BRCGH-inner > .BRCGH-language-switch {
    padding: 0.1rem;
    display: inline-block;
    list-style: none;
    border-radius: 0.9rem;
    background-color: #6c6b6b;
    height: 1.8rem;
    white-space: nowrap;
  }
  #BRCGH > .BRCGH-inner > .BRCGH-language-switch > .BRCGH-language {
    display: inline-block;
    padding: 0 8px;
    color: white;
    border: none;
    border-radius: 0.8rem;
    cursor: pointer;
    font-size: 1rem;
    font-weight: bold;
    line-height: 1.6;
    text-decoration: none;
  }
  #BRCGH > .BRCGH-inner > .BRCGH-language-switch > .BRCGH-language + .BRCGH-language {
    margin-left: -5px;
  }
  [lang|=en] #BRCGH > .BRCGH-inner > .BRCGH-language-switch > .BRCGH-language[data-language=english] {
    background-color: white;
    color: #5F5E5E;
    pointer-events: none;
  }
  [lang|=en] #BRCGH > .BRCGH-inner > .BRCGH-language-switch > .BRCGH-language[data-language=japanese] {
    background-color: transparent;
  }
  [lang=ja] #BRCGH > .BRCGH-inner > .BRCGH-language-switch > .BRCGH-language[data-language=japanese] {
    background-color: white;
    color: #5F5E5E;
    pointer-events: none;
  }
  [lang=ja] #BRCGH > .BRCGH-inner > .BRCGH-language-switch > .BRCGH-language[data-language=english] {
    background-color: transparent;
  }
  
  @media screen and (max-width: 480px) {
    #BRCGH {
      min-width: auto;
      position: fixed;
      top: 0;
      height: 50px;
    }
    #BRCGH > .BRCGH-inner {
      height: auto;
    }
    #BRCGH > .BRCGH-inner > .BRCGH-logotype > a {
      width: 135px;
      height: 38px;
    }
    #BRCGH > .BRCGH-inner > .BRCGH-logotype > a::before {
      width: 136px;
      height: 7px;
    }
    #BRCGH > .BRCGH-inner > nav {
      display: none;
    }
    #BRCGH > .BRCGH-inner > .BRCGH-hamburger-menu {
      position: relative;
      left: 13px;
      width: 40px;
      height: 50px;
    }
    #BRCGH > .BRCGH-inner > .BRCGH-hamburger-menu::before, #BRCGH > .BRCGH-inner > .BRCGH-hamburger-menu::after {
      content: "";
      display: block;
      position: absolute;
      width: 20px;
      height: 1px;
      background-color: #666666;
      left: 5px;
      transition: transform 0.4s;
    }
    #BRCGH > .BRCGH-inner > .BRCGH-hamburger-menu::before {
      top: 19px;
      box-shadow: 0 5.5px 0 #666666;
    }
    #BRCGH > .BRCGH-inner > .BRCGH-hamburger-menu::after {
      bottom: 19px;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav {
      padding: 0;
      display: block;
      position: absolute;
      top: 50px;
      left: 0;
      width: 100%;
      background-color: white;
      border-top: var(--border-separator);
      box-shadow: 0 10px 10px rgba(0, 0, 0, 0.25);
      max-height: calc(100vh - 50px);
      overflow-y: auto;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary, #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-secondary {
      font-size: 16px;
      line-height: 18px;
      text-align: left;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li, #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-secondary > li {
      display: block;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li + li, #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-secondary > li + li {
      margin-left: 0;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > a, #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-secondary > li > a {
      padding: var(--padding-sp-item);
      display: block;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > a {
      display: none;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view {
      position: relative;
      top: 0;
      box-shadow: none;
      pointer-events: auto;
      opacity: 1;
      transform: translateY(0px);
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-popupmenu-title {
      padding-left: 16px;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > header {
      padding: var(--padding-sp-item);
      font-size: 14px;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns {
      padding: 0;
      display: block;
      min-width: auto;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column {
      width: 100%;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column > .BRCGH-column-title {
      margin-bottom: 0;
      border-bottom: none;
      position: relative;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column > .BRCGH-column-title > a {
      display: block;
      padding: var(--padding-sp-item);
      border-top: var(--border-separator);
      font-size: 14px;
      line-height: 1.4;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column.-BRCGH-haschild > .BRCGH-column-title > a {
      padding-right: 36px;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column.-BRCGH-haschild > .BRCGH-column-title > .BRCGH-collapsebutton {
      position: absolute;
      top: 2px;
      right: 2px;
      width: 28px;
      height: 36px;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column.-BRCGH-haschild > .BRCGH-column-title > .BRCGH-collapsebutton::before, #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column.-BRCGH-haschild > .BRCGH-column-title > .BRCGH-collapsebutton::after {
      content: "";
      display: block;
      position: absolute;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column.-BRCGH-haschild > .BRCGH-column-title > .BRCGH-collapsebutton::before {
      width: 11px;
      height: 11px;
      border: solid 1px var(--color-key1);
      top: 10px;
      right: 6px;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column.-BRCGH-haschild > .BRCGH-column-title > .BRCGH-collapsebutton::after {
      width: 1px;
      height: 1px;
      top: 16px;
      right: 12px;
      background-color: var(--color-key1);
      box-shadow: 0 -1px 0 var(--color-key1), 0 -2px 0 var(--color-key1), 0 -3px 0 var(--color-key1), 0 1px 0 var(--color-key1), 0 2px 0 var(--color-key1), 0 3px 0 var(--color-key1), -1px 0 0 var(--color-key1), -2px 0 0 var(--color-key1), -3px 0 0 var(--color-key1), 1px 0 0 var(--color-key1), 2px 0 0 var(--color-key1), 3px 0 0 var(--color-key1);
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column.-BRCGH-haschild > ul {
      display: none;
      padding-top: 6px;
      padding-bottom: 6px;
      margin-top: -9px;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column.-BRCGH-haschild > ul > li > a {
      padding: 10px 16px;
      font-size: 12px;
      line-height: 1.4;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column.-BRCGH-haschild > ul > li > a::after {
      content: none;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column.-BRCGH-collapsed > .BRCGH-column-title > .BRCGH-collapsebutton::after {
      box-shadow: -1px 0 0 var(--color-key1), -2px 0 0 var(--color-key1), -3px 0 0 var(--color-key1), 1px 0 0 var(--color-key1), 2px 0 0 var(--color-key1), 3px 0 0 var(--color-key1);
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-primary > li > .BRCGH-popupmenu-view > .BRCGH-columns > .BRCGH-column.-BRCGH-collapsed > ul {
      display: block;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-secondary {
      padding-top: 8px;
      padding-bottom: 0;
      position: relative;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > nav > .BRCGH-secondary::before {
      content: "";
      display: block;
      width: 100%;
      height: 8px;
      background: linear-gradient(124deg, #212aaa -100%, #13b56e 200%);
      position: absolute;
      top: 0;
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > .BRCGH-hamburger-menu::before {
      box-shadow: none;
      transform: translateY(5px) rotate(45deg);
    }
    #BRCGH.-BRCGH-opened > .BRCGH-inner > .BRCGH-hamburger-menu::after {
      transform: translateY(-5px) rotate(-45deg);
    }
  }
  `;

  const style = document.createElement('style');
  style.textContent = CSS;
  if (isTest) {
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', 'css/BRCGH.css');
    document.querySelector('head').append(link);
  } else {
    document.head.appendChild(style);
  }

  // document.write(HTML);
  document.getElementById('BRC-global-header').insertAdjacentHTML('afterend', HTML);

  window.requestAnimationFrame(() => {

    const $ROOT = document.getElementById('BRCGH');
  
    // open and clos when on a cell phone
    $ROOT.querySelector('.BRCGH-hamburger-menu').addEventListener('click', () => $ROOT.classList.toggle('-BRCGH-opened'));

    // get parameters
    if (window.innerWidth > 480) {
      const width = DATASET.width;
      if (width) $ROOT.querySelectorAll('.BRCGH-inner').forEach(el => el.style.width = width + 'px');
    }

    // draw menu
    const fetchOptions = {
      method: 'GET',
      mode: 'cors',
      headers: {'Content-Type': 'application/json'}
    };
    Promise.all([
      fetch(
        DATASET.origin + 'wp-json/menus/v1/menus/global-header-v2',
        fetchOptions
      )
      .then(response => response.json()),
      fetch(
        DATASET.origin + 'wp-json/menus/v1/menus/global-header-sub-v2',
        fetchOptions
      )
      .then(response => response.json())
    ])
    .then(values => {
      const [globalHeader, globalHeader2] = values;
      let html = '';
      // main menu
      html += `<ul class="BRCGH-primary">
        ${globalHeader.items.map(item => {
          return `<li>
            <a href="${item.url}">${item.title}</a>
            ${
              item.child_items
                ? `
                <div class="BRCGH-popupmenu-view" data-column-count="${item.child_items.length}">
                  <div class="BRCGH-popupmenu-title">${item.title}</div>
                  <div class="BRCGH-columns">
                    ${item.child_items.map(childItem => {
                      const hasChild = childItem.child_items !== undefined;
                      return `<div class="BRCGH-column${
                        hasChild ? ' -BRCGH-haschild': ''
                      }">
                        <h3 class="BRCGH-column-title">
                          <a href="${childItem.url}">${childItem.title}</a>
                          ${
                            hasChild ? '<button class="BRCGH-collapsebutton" tabindex="-1"></button>' : ''
                          }
                        </h3>
                        ${
                          hasChild
                            ? `<ul>
                              ${childItem.child_items?.map(grandChildItem => {
                                return `<li>
                                <a href="${grandChildItem.url}">${grandChildItem.title}</a>
                                </li>`;
                              }).join('')}
                            </ul>`
                            : ''
                        }
                      </div>`;
                    }).join('')}
                  </div>
                </div>`
                : ''
            }
          </li>`;
        }).join('')}
      </ul>`;
      // sub menu
      if (globalHeader2.items.length > 0) {
        html += `<ul class="BRCGH-secondary">
          ${globalHeader2.items.map(item => {
            return `<li>
              <a href="${item.url}">${item.title}</a>
            </li>`;
          })}
        </ul>`;
      }
      const $nav = $ROOT.querySelector('.BRCGH-inner > nav');
      $nav.innerHTML = html;

      // collapse
      $nav.querySelectorAll('.BRCGH-collapsebutton').forEach(button => {
        const parent = button.closest('.-BRCGH-haschild');
        button.addEventListener('click', () => parent.classList.toggle('-BRCGH-collapsed'));
      });

      // adjust position of popup menu
      window.addEventListener('resize', () => {
        const width = $ROOT.getBoundingClientRect().width - 4;
        $ROOT.querySelectorAll('.BRCGH-popupmenu-view').forEach(node => {
          const rect = node.getBoundingClientRect();
          const parentRect = node.parentNode.getBoundingClientRect();
          const padding = 4;
          let left = rect.width * -.5 + parentRect.width * .5;
          const surplus = parentRect.left + left + rect.width - width + padding;
          left -= surplus > 0 ? surplus : 0;
          node.style.left = `${left}px`;
        });
      });
      window.dispatchEvent(new Event('resize'));

      // fire event
      window.dispatchEvent(new CustomEvent('BRCGHReady'));
    });

    // lang switch
    languageSwitcher();
    function languageSwitcher() {
      const isLanguageSwitch = DATASET.languageSwitch;
      if (!isLanguageSwitch) return;

      $ROOT.querySelector('.BRCGH-inner > nav').insertAdjacentHTML('afterend', '<div class="BRCGH-language-switch"><button class="BRCGH-language" data-language="japanese">JPN</button><button class="BRCGH-language" data-language="english">ENG</button></div>');

      const replace = {
        ja: {
          regexp: new RegExp(/\/ja\//),
          text: '/en/'
        },
        en: {
          regexp: new RegExp(/\/en\//),
          text: '/ja/'
        }
      }
      const languageSwitchButtons = $ROOT.querySelectorAll('.BRCGH-inner > .BRCGH-language-switch > .BRCGH-language');
      languageSwitchButtons.forEach(button => {
        button.addEventListener('click', () => {
          transition();
          return false;
        });
        button.addEventListener('keyup', e => {
          if (e.which === 13) {
            transition();
          } else {
            return false;
          }
        });
      });
      function transition() {
        window.location.href = window.location.href.replace(replace[lang].regexp, replace[lang].text);
      }
    }
  
  });

})();
